import { render, staticRenderFns } from "./AtcAutorizeModel.vue?vue&type=template&id=4d53988a&"
import script from "./AtcAutorizeModel.vue?vue&type=script&lang=js&"
export * from "./AtcAutorizeModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports